import { createFileRoute } from "@tanstack/react-router";
import { Prose } from "@/components/site/PageHeader";
import { EditablePageShell } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";

export const Route = createFileRoute("/legal/accessibility")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("legal/accessibility")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Accessibility — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "Our commitment to making glowlonggolf.com accessible to everyone, including users of assistive technology." },
      { property: "og:title", content: loaderData?.title || "Accessibility — Glow Long Golf" },
      { property: "og:description", content: loaderData?.meta_description || "Our commitment to making glowlonggolf.com accessible to everyone, including users of assistive technology." },
      { property: "og:url", content: "https://glowlong.lovable.app/legal/accessibility" },
    ],
    links: [{ rel: "canonical", href: "https://glowlong.lovable.app/legal/accessibility" }],
  }),
  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: () => (
    <EditablePageShell slug="legal/accessibility" defaults={{ eyebrow: "Legal", title: "Accessibility statement" }}>
      <Prose>
        <p>We strive to make glowlonggolf.com accessible to as many people as possible, including users of assistive technology. The site is built with semantic HTML, accessible color contrast, keyboard navigation, and ARIA labels for interactive elements where appropriate.</p>
        <p>If something doesn't work well for you, please email us — we want to fix it.</p>
      </Prose>
    </EditablePageShell>
  ),
});
